const styles = {
  container: {
    maxWidth: 600,
    width: "90%",
    margin: "20px auto",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    textAlign: "center",
    padding: "30px 20px",
    backgroundColor: "#ffffff",
    borderRadius: 24,
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
    position: 'relative',
    overflow: 'hidden',
  },
  gameOverContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    marginTop: '20px',
    animation: 'fadeIn 0.5s ease-out',
  },
  scoreSummary: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '10px',
  },
  scoreItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
    padding: '10px 20px',
    borderRadius: '12px',
    minWidth: '80px',
  },
  scoreLabel: {
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#666',
    marginBottom: '4px',
    fontWeight: 'bold',
  },
  scoreValue: {
    fontSize: '20px',
    fontWeight: '800',
    color: '#2c3e50',
  },
  mobileButton: {
    width: '100%',
    padding: '16px',
    fontSize: '20px',
    fontWeight: 'bold',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
    border: 'none',
    transform: 'scale(1.02)',
    transition: 'transform 0.2s',
  },
  nextPuzzleTimer: {
    marginTop: 20,
    padding: 20,
    backgroundColor: '#e3f2fd',
    borderRadius: 16,
    color: '#0d47a1',
    width: '100%',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    border: '1px solid #bbdefb',
  },
  title: {
    fontSize: 36,
    marginBottom: 5,
  },
  subtitle: {
    fontSize: 20,
    marginTop: 0,
    marginBottom: 10,
    fontWeight: "bold",
  },
  instructions: {
    fontSize: 16,
    marginBottom: 15,
  },
  todayTheme: {
    fontSize: 18,
    marginBottom: 20,
    fontWeight: "bold",
  },
  hintsContainer: {
    marginBottom: 20,
    textAlign: "left",
  },
  hint: {
    padding: "12px 16px",
    borderRadius: 10,
    marginBottom: 10,
    fontSize: 16,
    boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
    fontWeight: 500,
  },
  button: {
    backgroundColor: "#1565c0",
    border: "none",
    color: "white",
    padding: "10px 20px",
    fontSize: 16,
    borderRadius: 6,
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  form: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  input: {
    padding: 10,
    fontSize: 16,
    width: 220,
    borderRadius: 6,
    border: "1px solid #ccc",
  },
  guesses: {
    marginTop: 20,
    fontSize: 16,
    color: "#555",
  },
  message: {
    marginTop: 15,
    fontWeight: "600",
    fontSize: 18,
  },
  funFact: {
    marginTop: 25,
    padding: 15,
    backgroundColor: "#fff3e0",
    borderRadius: 8,
    fontStyle: "italic",
    fontSize: 16,
    color: "#f57c00",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  loading: {
    fontSize: 18,
    color: "#666",
  },
  answerBox: {
    margin: "0",
    padding: "15px",
    backgroundColor: "#f1f8e9",
    borderRadius: 8,
    border: "2px solid #81c784",
    width: "100%",
  },
  answerLabel: {
    fontSize: 14,
    color: "#558b2f",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginBottom: 5,
    fontWeight: "bold",
  },
  answerValue: {
    fontSize: 28,
    color: "#2e7d32",
    fontWeight: "800",
  },
  linkButton: {
    background: "none",
    border: "none",
    color: "#1565c0",
    fontSize: 15,
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "underline",
    padding: 0,
  },
  backButton: {
    background: "none",
    border: "none",
    color: "#546e7a",
    fontSize: 15,
    fontWeight: "600",
    cursor: "pointer",
    padding: 0,
    marginBottom: 15,
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  roundHeader: {
    fontSize: 20,
    fontWeight: "800",
    color: "#1565c0",
    marginBottom: 4,
  },
  roundPrompt: {
    fontSize: 15,
    color: "#78909c",
    fontStyle: "italic",
    marginBottom: 15,
  },
  summaryList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginBottom: 20,
    textAlign: "left",
  },
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    padding: "10px 14px",
    borderRadius: 10,
    backgroundColor: "#f1f8e9",
    border: "1px solid #c5e1a5",
    fontSize: 15,
    color: "#2c3e50",
  },
  archiveList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    marginTop: 15,
    maxHeight: 420,
    overflowY: "auto",
    textAlign: "left",
  },
  archiveItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 16px",
    borderRadius: 12,
    backgroundColor: "#f8f9fa",
    border: "1px solid #eceff1",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
  },
  archiveItemTitle: {
    fontSize: 15,
    fontWeight: "700",
    color: "#2c3e50",
    marginBottom: 2,
  },
  archiveItemMeta: {
    fontSize: 13,
    color: "#78909c",
  },
  archiveBadge: {
    fontSize: 14,
    fontWeight: "700",
    whiteSpace: "nowrap",
    marginLeft: 10,
  },
};

export default styles;
